import Goal from "./Goal";

export default Goal;
